<template>
  <button @click="handleClick" class="button" :class="{ '-active': isActive }">
    {{ label }}
  </button>
</template>

<script lang="ts">
export default {
  name: 'FavoriteButton',

  props: {
    label: {
      type: String,
      default: 'ボタンラベル'
    },

    isActive: {
      type: Boolean,
      default: false
    },

    handleClick: Function
  }
}
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.button {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  max-width: 215px;
  height: 50px;
  margin-left: auto;
  margin-right: auto;
  border: 1px solid var.$color-border-gray;
  border-radius: 40px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
  font-weight: bold;
  font-size: 1.4rem;
  text-align: center;
  background-color: #f5f5f5;
  color: #666;
  font-weight: normal;
  transition: 0.2s;

  &:hover {
    opacity: 1;
    background-color: #e5f7f6;
  }

  &::before {
    content: '';
    display: block;
    margin-right: 8px;
    width: 20px;
    height: 18px;
    background-image: url('~@/assets/icon/heart.svg');
    background-size: 20px 18px;
  }

  &.-active::before {
    background-image: url('~@/assets/icon/heart_on.svg');
    background-size: 20px 18px;
  }
}
</style>
